import { message, Modal } from "antd";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import InputField from "../../../reusable-components/TNInputField";
import { InputfieldTypes } from "../../../enums/InputFieldAttributesEnums";
import { AddRoleModalConsts } from "./constants";
import RolesServices from "../../../services/roles.services";
import TNLoader from "../../../reusable-components/TNLoader";
import { useQueryClient } from "@tanstack/react-query";

interface AddRoleModalProps {
  isOpen: boolean;
  handleClose: () => void;
  roleId: string;
  roleName: string;
}

const AddRoleModal = ({
  isOpen,
  handleClose,
  roleId,
  roleName,
}: AddRoleModalProps) => {
  const queryClient = useQueryClient();
  const { reset, handleSubmit, getValues, setValue } = useFormContext();
  const {
    TITLE,
    LABEL,
    FIELD_NAME,
    PLACEHOLDER,
    ADD_SUCCESS_MSG,
    EDIT_SUCCESS_MSG,
  } = AddRoleModalConsts;

  const { AddExternalRoleEntry, EditExternalRoleEntry } = RolesServices();

  const { mutateAsync: addRole, isPending: addRolePending } =
    AddExternalRoleEntry({});
  const { mutateAsync: editRole, isPending: editRolePending } =
    EditExternalRoleEntry();

  const handleCancel = () => {
    reset();
    handleClose();
  };

  const handleSave = async () => {
    const roleNameValue = getValues(FIELD_NAME);
    if (!!roleId) {
      const payload = {
        roleName: roleNameValue,
        roleId: roleId,
      };
      await editRole(payload, {
        onSuccess: () => {
          message.success(EDIT_SUCCESS_MSG);
        },
        onError: (error) => {
          message.error(error?.response?.data?.message);
        },
      });
    } else {
      await addRole(roleNameValue, {
        onSuccess: () => {
          message.success(ADD_SUCCESS_MSG);
        },
        onError: (error) => {
          message.error(error?.response?.data?.message);
        },
      });
    }
    queryClient.invalidateQueries();
    handleCancel();
  };

  useEffect(() => {
    if (!!roleName) {
      setValue(FIELD_NAME, roleName);
    }
  }, [roleName]);

  return (
    <>
      <TNLoader isLoading={addRolePending || editRolePending} />
      <Modal
        title={TITLE}
        visible={isOpen}
        onCancel={handleCancel}
        closable={true}
        onOk={() => {
          handleSubmit(handleSave)();
        }}
      >
        <InputField
          type={InputfieldTypes.TEXT}
          label={LABEL}
          name={FIELD_NAME}
          placeholder={PLACEHOLDER}
          requiredField={true}
        />
      </Modal>
    </>
  );
};

export default AddRoleModal;
